import { render, staticRenderFns } from "./UserDetails_Icon_Small.vue?vue&type=template&id=2c74716e&"
import script from "./UserDetails_Icon_Small.vue?vue&type=script&lang=js&"
export * from "./UserDetails_Icon_Small.vue?vue&type=script&lang=js&"
import style0 from "./UserDetails_Icon_Small.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports